import { render, staticRenderFns } from "./ApplyGradeFromButton.vue?vue&type=template&id=da2c826a&"
import script from "./ApplyGradeFromButton.vue?vue&type=script&lang=js&"
export * from "./ApplyGradeFromButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports